import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { LEGAL_VERSION } from "../lib/legalContent";
import { Button } from "./ui/button";

export default function TermsNotice() {
  const { user, setUser, isKid, logout } = useAuth();
  const { pathname } = useLocation();
  const [busy, setBusy] = useState(false);
  if (!user || isKid || user.terms_version === LEGAL_VERSION || ["/terms", "/privacy"].includes(pathname)) return null;

  const accept = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/auth/accept-terms");
      setUser({ ...user, terms_version: data.terms_version });
      toast.success("Thanks for accepting 💛");
    } catch { toast.error("Could not save — please try again"); }
    finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-[60] bg-slate-900/50 backdrop-blur-sm flex items-center justify-center p-4" data-testid="terms-notice">
      <div className="bg-white rounded-3xl shadow-2xl max-w-md w-full p-7">
        <span className="h-12 w-12 rounded-2xl bg-[#2AB7CA]/10 text-[#2AB7CA] flex items-center justify-center"><ShieldCheck className="h-6 w-6" /></span>
        <h2 className="mt-4 text-2xl font-display font-bold text-slate-900">We've updated our terms</h2>
        <p className="text-slate-500 mt-2 text-sm leading-relaxed">
          To keep using Bubz +, please review and accept our new{" "}
          <Link to="/terms" data-testid="notice-terms-link" className="font-bold text-[#9B5DE5] hover:underline">Terms &amp; Conditions</Link> and{" "}
          <Link to="/privacy" data-testid="notice-privacy-link" className="font-bold text-[#9B5DE5] hover:underline">Privacy Policy</Link>.
          They explain how we protect children across streaming, the Playground, the Marketplace and messages.
        </p>
        <Button onClick={accept} disabled={busy} data-testid="notice-accept-btn"
          className="w-full h-12 rounded-xl font-bold bg-[#FF5A79] hover:bg-[#e04865] mt-6">
          {busy ? "Saving…" : "I agree"}
        </Button>
        <button onClick={logout} data-testid="notice-signout-btn" className="w-full mt-3 text-sm text-slate-400 hover:text-slate-600">Sign out instead</button>
      </div>
    </div>
  );
}
